export const initialState = {
  CategoryList: [],
  CategoryDetail: {},
  CategoryPage: {}
};
